import { useState } from 'react';
import { Bell, BellOff, Vibrate, VibrateOff } from 'lucide-react';

const KEY = 'restAlertPrefs';
const read = () => {
  try { return { sound: true, buzz: true, ...JSON.parse(localStorage.getItem(KEY) || '{}') }; } catch { return { sound: true, buzz: true }; }
};

export const useRestAlertPrefs = () => {
  const [prefs, setPrefs] = useState(read);
  const toggle = (k) => setPrefs((p) => {
    const next = { ...p, [k]: !p[k] };
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  });
  return [prefs, toggle];
};

const Pill = ({ on, onClick, IconOn, IconOff, label, testId }) => (
  <button
    type="button" onClick={onClick} aria-pressed={on} data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-semibold border transition-colors ${on ? 'border-primary/50 bg-primary/10 text-primary' : 'border-white/10 bg-white/[0.04] text-white/40'}`}
  >
    {on ? <IconOn className="h-3.5 w-3.5" /> : <IconOff className="h-3.5 w-3.5" />}
    {label} {on ? 'on' : 'off'}
  </button>
);

export const RestAlertToggles = ({ prefs, toggle }) => {
  const canBuzz = typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
  return (
    <div className="mt-3 flex items-center justify-center gap-2" data-testid="rest-alert-toggles">
      <Pill on={prefs.sound} onClick={() => toggle('sound')} IconOn={Bell} IconOff={BellOff} label="Chime" testId="rest-alert-sound-toggle" />
      {canBuzz && <Pill on={prefs.buzz} onClick={() => toggle('buzz')} IconOn={Vibrate} IconOff={VibrateOff} label="Buzz" testId="rest-alert-buzz-toggle" />}
    </div>
  );
};

export default RestAlertToggles;
